import styled from 'styled-components';
import { propStyles } from '../../../utils/propStyles';

const StyledComponent = styled<any, any>('span')`
    ${propStyles};
`;

StyledComponent.defaultProps = {};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Modal/StyledComponents/ModalTitle.tsx